import { Injectable } from '@angular/core';
import { AbstractControl,ValidatorFn, Validators } from '@angular/forms';

@Injectable()
export class UrlValidators {

    validateUrl(): ValidatorFn  {
        return (control: AbstractControl): { [key: string]: any } => {
            if (!control.value || control.value == "") return null;

            let rgx = new RegExp(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/);

            return (!rgx.test(control.value) ? { 'invalidUrl': { value: control.value } } : null);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/exa/_validators/url.validators.ts